/* eslint-disable no-param-reassign */
import axios from 'axios';
// import { fetch } from 'whatwg-fetch';

import { getAuthData, clearAuthData } from './authStorage';
import {
  API_URL,
  TEST_ENVIRONMENT,
  BORROWER_API_URL,
  LENDER_API_URL,
} from '../constants/main';
import { useServicerStore, useUiStore } from '../store';

// Urls that should not cause redirect to login page if error 401 is returned
const excludedUrls = [
  '/auth/accept/',
  'auth/login',
  '/auth/validate_quick_auth_code',
  'auth/me',
];

axios.defaults.baseURL = API_URL;

// Change base url based on user role
useServicerStore.subscribe((state) => {
  if (
    state.userRole === 'borrower' &&
    axios.defaults.baseURL !== BORROWER_API_URL
  ) {
    console.log('CHANGE BASE_URL TO BORROWER_API_URL');
    axios.defaults.baseURL = BORROWER_API_URL;
  } else if (
    state.userRole === 'lender' &&
    axios.defaults.baseURL !== LENDER_API_URL
  ) {
    console.log('CHANGE BASE_URL TO LENDER_API_URL');
    axios.defaults.baseURL = LENDER_API_URL;
  } else if (
    state.userRole !== 'borrower' &&
    state.userRole !== 'lender' &&
    axios.defaults.baseURL !== API_URL
  ) {
    console.log('CHANGE BASE_URL TO API_URL');
    axios.defaults.baseURL = API_URL;
  }
});

axios.interceptors.request.use(
  (config) => {
    const customConfig = { ...config };
    const { accessToken } = getAuthData();
    if (accessToken) {
      customConfig.headers.Authorization = `Bearer ${accessToken}`;
    }

    if (TEST_ENVIRONMENT) {
      customConfig.headers['X-Data-Source'] = 'test';
    }

    return customConfig;
  },
  (error) => {
    Promise.reject(error);
  }
);

axios.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    const originalRequest = error.config;
    if (error?.response?.status === 401 && !originalRequest._retry) {
      if (
        error.response.data?.message !== 'User does not have servicer access' &&
        !excludedUrls.some((url) => originalRequest.url.includes(url))
      ) {
        clearAuthData();

        // Before redirecting to login page, we need to save the current url to redirect back to it after login
        useUiStore.setState({
          redirectUrl: window.location.pathname + window.location.search,
        });

        // window.location.href = '/login';
      }

      return Promise.reject(error);
    }

    return Promise.reject(error);
  }
);
